<template>
  <div>
    <div id="bar1" style="width: 590px; height: 380px"></div>
  </div>
</template>
  <script>
export default {
  name: "bar1",
  props: {
    barData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      timesin3: null
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    barData() {
      clearInterval(this.timesin3);
      this.init();
    }
  },
  methods: {
    init() {
      let myChart = this.$echarts.init(document.getElementById("bar1"));
      let option = {
        grid: {
          left: "5%",
          right: "5%",
          bottom: "3%",
          top: "5%",
          containLabel: true
        },
        xAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          inverse: true,
          data: this.barData.echartsY,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: "#004ea5",
            fontSize: 16
          }
        },
        series: [
          {
            type: "bar",
            data: this.barData.echartsX,
            barWidth: 10,
            color: "#0178dd",
            label: {
              show: true,
              position: "right",
              formatter: "{c}",
              fontSize: 14,
              fontWeight: "bold"
            }
          }
        ]
      };
      myChart.clear();
      myChart.setOption(option);
      this.timesin3 = setInterval(function() {
        myChart.clear();
        myChart.setOption(option);
      }, 25000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.timesin3);
        this.timesin3 = null;
      });
    }
  }
};
</script>